import classNames from 'classnames/bind';
import styles from './ClassicDetails.module.scss';
import OutlinedButton from '~/components/common/outlined-button/OutlinedButton';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon } from '~/assets/icons';
import ClosedInvoice from './table/closed-invoices/ClosedInvoice';
import MyTask from './table/my-task/MyTask';
import InvoiceOpenSalesRep from './table/invoice-open-sales-rep/InvoiceOpenSalesRep';
import PaidAndLeftReview from './table/paid-and-left-review/PaidAndLeftReview';
import Payment from './table/payment/Payment';
import MyPayments from './table/my-payments/MyPayments';
import Roofs from './table/roofs/Roofs';
import ShelbyvilleJob from './table/shelbyville-job/ShelbyvilleJob';
import ShingleColor from './table/shingle-color/ShingleColor';
import Shingle from './table/shingle/Shingle';
import InvoiceOpen from './table/invoice-open/InvoiceOpen';
import InvoiceListing from './table/invoice-listings/InvoiceListing';
import JobsInProgressCompleted from './table/jobs-in-progress-completeds/JobsInProgressCompleted';

const cx = classNames.bind(styles);

const CLASSIC_REPORT_COMPONENTS: Record<string, React.ComponentType> = {
    'closed-invoices': ClosedInvoice,
    'my-tasks': MyTask,
    'invoice-open-sales-rep': InvoiceOpenSalesRep,
    'paid-and-left-review': PaidAndLeftReview,
    'payments': Payment,
    'my-payments': MyPayments,
    'invoice-opens': InvoiceOpen,
    'invoice-listings': InvoiceListing,
    'jobs-in-progress-completeds': JobsInProgressCompleted,
    'roofs': Roofs,
    'shelbyville-job': ShelbyvilleJob,
    'shingle-color': ShingleColor,
    'shingle': Shingle,
};

const ClassicDetails = () => {
    const navigate = useNavigate();
    const { path } = useParams<{ path: string }>();
    const ReportComponent = path ? CLASSIC_REPORT_COMPONENTS[path] : null;

    return (
        <div className={cx('classic-details-container')}>
            <div className={cx('classic-details-content')}>
                <OutlinedButton
                    title="Back to Classic Reports"
                    onClick={() => navigate(-1)}
                    icon={<ArrowLeftIcon className={cx('back-icon')} />}
                    className={cx('back-button')}
                />

                <div className={cx('classic-details-content-body')}>
                    {ReportComponent ? (
                        <ReportComponent />
                    ) : (
                        <div className={cx('classic-details-not-found')}>
                            Report &quot;{path ?? ''}&quot; not found.
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ClassicDetails;
